module.exports = __webpack_public_path__ + "img/bg_kb_type4.6ce49e3e.png";